/**
 * Debug logger utility for development
 * Only logs for specific debug users configured in environment
 */

import { TylerState } from './TylerState';

// Get debug email from environment, fallback to tylerhargrave@gmail.com for development
const DEBUG_EMAIL = process.env.REACT_APP_DEBUG_USER_EMAIL || 'tylerhargrave@gmail.com';

/**
 * Log debug information only for configured debug users
 * @param action - Action being performed (e.g., "SAVE TRIGGERED", "LOADING DATA")
 * @param data - Optional data to log (will be stringified)
 */
export const debugLog = (action: string, data?: Record<string, unknown>): void => {
  const currentUser = TylerState.user;
  if (currentUser?.email === DEBUG_EMAIL) {
    console.log(`🔍 ${action}:`, data || '');
  }
};

/**
 * Log errors only for configured debug users
 * @param action - Action that failed
 * @param error - Error object or message
 */
export const debugError = (action: string, error: unknown): void => {
  const currentUser = TylerState.user;
  if (currentUser?.email === DEBUG_EMAIL) {
    console.error(`❌ ${action}:`, error);
  }
};

/**
 * Check if current user is a debug user
 */
export const isDebugUser = (): boolean => {
  const currentUser = TylerState.user;
  return currentUser?.email === DEBUG_EMAIL;
};
